module.exports = __webpack_public_path__ + "img/5_107.c805a8da.png";